import { render, staticRenderFns } from "./ReviewPersonalDetails.vue?vue&type=template&id=01bb88a7&scoped=true"
import script from "./ReviewPersonalDetails.vue?vue&type=script&lang=ts"
export * from "./ReviewPersonalDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReviewPersonalDetails.vue?vue&type=style&index=0&id=01bb88a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb88a7",
  null
  
)

export default component.exports